/**
 * Argus — utilitar formatare bytes (folosit cross-panel-uri).
 *
 * Notă: fișierul a fost cleaned 2026-05-05 după switchover la WS direct flow
 * pentru `dir_listing`. Tipurile DTO + helpers REST (`DirListingResult`,
 * `fetchArtifactJson`, `loadPathHistory`, `pushPathHistory`) au fost eliminate.
 * Acum `wsClient.requestDirListing` e singura cale de obținere directory listing.
 */

export function formatBytes(bytes: number | null): string {
  if (bytes === null) {
    return '—';
  }
  if (bytes < 1024) {
    return `${bytes} B`;
  }
  const units = ['KB', 'MB', 'GB', 'TB'];
  let value = bytes / 1024;
  let unitIdx = 0;
  while (value >= 1024 && unitIdx < units.length - 1) {
    value /= 1024;
    unitIdx += 1;
  }
  return `${value.toFixed(value >= 100 ? 0 : value >= 10 ? 1 : 2)} ${units[unitIdx]}`;
}
